import React, { Component } from 'react';
import styles from './PartnershipBlock.scss';


export default class PartnershipBlock extends Component {
  render() {
    return (
      <div className={ styles.partnershipBlock }>
        <div className={ styles.wrapper }>

          <h1 className={ styles.header }>
            Хотите стать партнером?
          </h1>

          <div className={ styles.turnoverTrackBlock }>
            <h2 className={ styles.turnoverDescription }>
              Оборот в месяц:
            </h2>
            <div className={ styles.turnoverTrack }>
              <div className={ styles.turnoverTrackLine } />
              <div
                data-amount="10 т. &#8381;"
                className={ styles.turnoverDot } />
              <div
                data-amount="100 т. &#8381;"
                className={ styles.turnoverDot } />
              <div
                data-amount="500 т. &#8381;"
                className={ styles.turnoverDot } />
              <div
                data-amount="1 млн. &#8381;"
                className={ `${styles.turnoverDot} ${styles.turnoverDotActive}` } />
              <div
                data-amount="3 млн. &#8381;"
                className={ styles.turnoverDot } />
              <div
                data-amount="5 млн. &#8381;"
                className={ styles.turnoverDot } />
              <div
                data-amount="10 млн. &#8381;"
                className={ styles.turnoverDot } />
            </div>
          </div>

          <div className={ styles.incomeBlock }>
            <h2 className={ styles.incomeBlockDescription }>
              Прибыль
            </h2>
            <div className={ styles.incomeBlockBtnsContainer}>
              <button className={ styles.btnAmount }>500 000 <span className="price">&#8381;</span></button>
              <button className={ styles.btnRegister }>
                Зарегистрироваться
              </button>
            </div>
          </div>

        </div>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/PartnershipBlock/PartnershipBlock.jsx
 **/